import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { viewUserProfile } from 'modules/app';
import NavbarComponents from '../components';

function mapStateToProps(state) {
  return {
    literals: state.i18n.literals.navbar || {},
    navbarData: state.navbar,
    user: state.session.user,
    app: state.app,
    actualContext: state.steps.context,
  };
}

const mapDispatchToProps = {
  viewUserProfile,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(NavbarComponents));



// WEBPACK FOOTER //
// ./src/components/Navbar/container/index.js